
import logoutStyle from "../../assets/scss/Logout.module.scss";
import Button from "../utils/Button";
import * as Tone from 'tone';
import CardLayout from "../utils/CardLayout";
import Modal from "../utils/Modal";


const Logout = ({ setLogoutModal, showlogoutModal }) => {

    const playLogoutSound = async () => {
        await Tone.start();
        const synth = new Tone.Synth({
            oscillator: { type: 'sine' },
            envelope: {
                attack: 0.01,
                decay: 0.15,
                sustain: 0.05,
                release: 0.3,
            },
            volume: 6, // in decibels — increase this to make it louder (default is 0)
        }).toDestination();

        const now = Tone.now();
        synth.triggerAttackRelease('E5', '0.1', now);
        synth.triggerAttackRelease('C5', '0.15', now + 0.12);
    };


    const handleNo = () => {
        setLogoutModal(false);
    }

    const handleYes = () => {
        playLogoutSound();
        setLogoutModal(false);
        localStorage.removeItem("colt_wireless_token");
        setTimeout(() => {
            window.location.href = "/login";
        }, 200);
    }

    return (
        <Modal
            showModal={showlogoutModal}
            title="Confirm Logout"
            width={500}
            showFooter={false}
            onHide={handleNo}
        >
            <div className="text-center">
                <i className="ri-error-warning-line text-primary" style={{ fontSize: '60px' }}></i>
                <p className="name" style={{ fontWeight: '500' }}>Are you sure you want to log out?</p>
            </div>

            <div className="d-flex justify-content-end mt-4 gap-3">
                <div className="">
                    <Button
                        title="No"
                        buttonType='button'
                        variant="secondary"
                        onClick={() => handleNo()}
                        style={{ padding: "4px 18px", fontWeight: '600', fontSize: '15px' }}
                    />
                </div>
                <div className="">
                    <Button
                        title="Yes"
                        buttonType='button'
                        variant="primary"
                        onClick={() => handleYes()}
                        style={{ padding: "4px 18px", fontWeight: '600', fontSize: '15px' }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default Logout;

